// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__rU+2V","tr":"ThongTinDonvi_tr__qwR5f"};